import { BrowserModule } from '@angular/platform-browser';
import '@angular/compiler';
import { NgModule, LOCALE_ID, DEFAULT_CURRENCY_CODE, APP_INITIALIZER } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CorrectedHttpClientModule } from './_infrastructure/http/http-params-builder.module';
import { CorrectedHttpClient } from './_infrastructure/http/corrected-http-client';
import { HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { ptBrLocale } from 'ngx-bootstrap/locale';
import { NGX_MASK_CONFIG, NgxMaskModule } from 'ngx-mask';


//ARRANJAR EXEMPLOS
//import { HighchartsChartModule } from 'highcharts-angular';


import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

//import {
//  HighlightModule,
//  HIGHLIGHT_OPTIONS,
//  HighlightOptions
//} from "ngx-highlightjs";

import { CommaToPointPipe } from './_infrastructure/CommaToPointPipe';
import { EmptyToNullDirective } from './_infrastructure/emptyToNull';
import { ToQueryStringPipe } from './_infrastructure/ToQueryStringPipe';
import { LanguageService } from './_infrastructure/MultiLanguage/languageService';

import { ShellComponent } from './shell/shell.component';

import { HttpErrorHandler } from './_infrastructure/ExceptionHandler/HttpErrorHandler';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CurrencyFormatterDirective } from './_infrastructure/currency';
import { NumericDirective } from './_infrastructure/numeric';
import { PercentageDirective } from './_infrastructure/percentage.pipe';

import { StripUndefinedParams } from './_infrastructure/StripUndefinedParams';
import { CurrencyPipe, DatePipe} from '@angular/common';
import { CommonDataPipe, CommonDataListPipe  } from './_infrastructure/CommonData/CommonDataPipe';
import { DebounceClickDirective } from './_infrastructure/DebounceClickDirective';
import { DragDropDirective } from './_infrastructure/DragDropDirective';
import { MaxValueDirective, MinValueDirective } from './_infrastructure/MinMaxValueDirectives';
import { ClearRelatedFieldsDirective } from './_infrastructure/ClearRelatedFieldsDirective';
import { ExactLengthDirective } from './_infrastructure/ExactLengthDirective';
import { DropdownTitleDirective } from './_infrastructure/DropdownTitleDirective';
import { NSIAuthService } from './_infrastructure/NSIAuthService/NSIAuthService';
import '../Scripts/json.date-extensions/json.date-extensions';
//@ts-ignore
JSON.useDateParser();

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/locale_', '.json');
}

export function initConfig(configService: SystemInformationService, authServ: NSIAuthService) {
  return () => {
    configService.loadCurrentSystemInformation().subscribe(res => {
      if (res.proveniencia == "NSI") {
        authServ.refreshToken();
      }
    })
    
  };
}

import { AlertModule } from './_infrastructure/Alerts/alert.module';


//SHARED COMPONENTS
import { WorkflowComponent } from './workflows/workflow.component';
import { StepComponent } from './workflows/step.component'
import { WorkflowSearchComponent } from './workflow-search/workflow-search.component';
import { SubscriberInfoComponent } from './_infrastructure/SubscriberInfo/subscriber-info.component'
import { BaseModalComponent } from './_infrastructure/Modal/base-modal.component';
import { DefaultDropdownValueComponent } from './_infrastructure/DefaultDropdownValue.component';
import { NullableSelectDirective } from './_infrastructure/NullableSelectValueAcessor';
import { LoadingMaskComponent } from './_infrastructure/LoadingMask/loading-mask.component';
import { SubmissionLandingPageComponent } from './SubmissionLandingPage/submission-landing-page.component';
import { ExSubsConfirmSubmissionComponent } from './SubmissionLandingPage/exsub-confirm-submission.component';
import { ConfirmSubmissionComponent } from './SubmissionLandingPage/confirm-submission.component';
import { NoCacheInterceptor } from './_infrastructure/NoCacheInterceptor';
import { InstanceBrowserComponent } from './instance-browser/instance-browser.component';
import { InstanceBrowserDetailComponent } from './instance-browser/instance-browser-detail.component';

import { ValidatePGPOnlineComponent } from './validate-pgp-online.component';


//CARDS
import { SubscriberIdentificationComponent } from './workflows/cards/SubscriberIdentification/subscriber-identification.component'
import { SubscriberContactsComponent } from './workflows/cards/SubscriberContacts/subscriber-contacts.component'
import { ServiceIdentificationComponent } from './workflows/cards/ServiceIdentification/service-identification.component';
import { ExternalPensionStatusComponent } from './workflows/cards/ExternalPensionStatus/external-pension-status.component';
import { SubscriberFiscalInformationComponent } from './workflows/cards/SubscriberFiscalInformation/subscriber-fiscal-information.component';
import { SubscriberPaymentInformationComponent } from './workflows/cards/SubscriberPaymentInformation/subscriber-payment-information.component';
import { CGAPensionStatusComponent } from './workflows/cards/CGAPensionStatus/cga-pension-status.component';
import { EffectivityMapComponent } from './workflows/cards/EffectivityMap/effectivity-map.component';
import { MilitaryInformationComponent } from './workflows/cards/Militaryinformation/military-information.component';
import { TimeCountComponent } from './workflows/cards/TimeCount/time-count.component';
import { FamilyBenefitsComponent } from './workflows/cards/FamilyBenefits/family-benefits.component';
import { RemunerationsTrienniumComponent } from './workflows/cards/RemunerationsTriennium/remunerations-triennium.component';
import { RemunerationsLastUntilCutoffComponent } from './workflows/cards/RemunerationsLastUntilCutoff/remunerations-last-until-cutoff.component';
import { RemunerationsLastThreeYearsComponent } from './workflows/cards/RemunerationsLastThreeYears/remunerations-last-three-years.component';
import { RemunerationsCurrentMonthlyComponent } from './workflows/cards/RemunerationsCurrentMonthly/remunerations-current-monthly.component';
import { RemunerationsMilitaryComponent } from './workflows/cards/RemunerationsMilitary/remunerations-military.component';
import { DocumentationComponent } from './workflows/cards/Documentation/documentation.component';
import { DocumentationHelpComponent } from './workflows/cards/DocumentationHelp/documentation-help.component';
import { ObservationsComponent } from './workflows/cards/Observations/observations.component';
import { CommunicationDetailComponent } from './workflows/cards/CommunicationDetail/communication-detail.component';
import { ServiceContactsComponent } from './workflows/cards/ServiceContacts/service-contacts.component';
import { SendWorkflowComponent } from './workflows/cards/SendWorkflowComponent/send-workflow.component';

//CARDS INNER COMPONENTS
import { WorkAbroadTableEditComponent } from './workflows/cards/ExternalPensionStatus/work-abroad-table-edit.component';
import { EffectivityTableEditComponent } from './workflows/cards/EffectivityMap/effectivity-table-edit.component';
import { IncapacityTableEditComponent } from './workflows/cards/ClinicalInformation/clinical-situation-edit.component';
import { FamilyBenefitsTableEditComponent } from './workflows/cards/FamilyBenefits/family-benefits-table-edit.component';
import { RemunerationPeriodTableEditComponent } from './workflows/cards/RemunerationsShared/remuneration-period-table-edit.component';
import { RemunerationOtherTableEditComponent } from './workflows/cards/RemunerationsShared/remuneration-other-table-edit.component';
import { EffectivityTimelineComponent } from './workflows/cards/EffectivityMap/effectivity-timeline.component';
import { DocumentationTableEditComponent } from './workflows/cards/Documentation/documentation-table-edit.component';

//NOVO
//ngx-bootstrap
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker'
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

//SHELL
import { HeaderComponent } from './shell/header/header.component';

//GUIDELINES
//import { GuidelinesComponent } from './guidelines/guidelines.component';
//import { ButtonsComponent } from './guidelines/pages/components/buttons/buttons.component';
//import { ColorsComponent } from './guidelines/pages/design/colors/colors.component';
//import { IconsComponent } from './guidelines/pages/design/icons/icons.component';
//import { TypographyComponent } from './guidelines/pages/design/typography/typography.component';
//import { CardComponent } from './guidelines/pages/structure/card/card.component';
//import { SearchboxComponent } from './guidelines/pages/structure/searchbox/searchbox.component';
//import { TextfieldComponent } from './guidelines/pages/components/textfield/textfield.component';
//import { ButtonPrimaryComponent } from './guidelines/pages/components/buttons/button-primary/button-primary.component';
//import { ButtonSecondaryComponent } from './guidelines/pages/components/buttons/button-secondary/button-secondary.component';
//import { ButtonLinksComponent } from './guidelines/pages/components/buttons/button-links/button-links.component';
//import { ToastmessagesComponent } from './guidelines/pages/components/toastmessages/toastmessages.component';
//import { SelectComponent } from './guidelines/pages/components/select/select.component';
//import { CheckboxComponent } from './guidelines/pages/components/checkbox/checkbox.component';
import { WorkflowInstanceCreatorComponent } from './workflow-instance-creator/workflow-instance-creator.component';
import { ToIconPipe, ToIconClassPipe } from './_infrastructure/ToIconPipe';
//import { TableComponent } from './guidelines/pages/components/table/table.component';
//import { DatepickerComponent } from './guidelines/pages/components/datepicker/datepicker.component';
//import { SidebarComponent } from './guidelines/pages/structure/sidebar/sidebar.component';
//import { CollapseContentComponent } from './guidelines/pages/components/table/collapse-content/collapse-content.component';
//import { SpinnerComponent } from './guidelines/pages/components/spinner/spinner.component';


import { ValidationMessageComponent } from './_infrastructure/ValidationMessages/validationMessage.Component';
import { ValidationMessageService } from './_infrastructure/ValidationMessages/ValidationMessageService';
//import { ToogleButtonComponent } from './guidelines/pages/components/toogle-button/toogle-button.component';
//import { CardShadowComponent } from './guidelines/pages/structure/card-shadow/card-shadow.component';
//import { ModalComponent } from './guidelines/pages/components/modal/modal.component';
//import { TooltipComponent } from './guidelines/pages/components/tooltip/tooltip.component';
//import { TimelineComponent } from './guidelines/pages/components/timeline/timeline.component';
//import { FileinputComponent } from './guidelines/pages/components/fileinput/fileinput.component';
import { ExternalValidationsService } from './_infrastructure/ValidationMessages/ExternalValidationsService';
import { ExternalValidationDirective } from './_infrastructure/ValidationMessages/ExternalValidationDirective';
import { RowExternalValidationDirective } from './_infrastructure/ValidationMessages/RowExternalValidationDirective';
import { RadioLabelDirective } from './_infrastructure/RadioLabelDirective';
import { SubscriberInformationService } from './_infrastructure/SubscriberInfo/SubscriberInformationService';
import { VisualActionUnauthorizedDirective } from './_infrastructure/Security/visualaction-unauthorized.directive';
import { SystemInformationService } from './_infrastructure/SystemInformation/SystemInformationService';
import { AsyncDataService } from './_infrastructure/AsyncData/AsyncDataService';
import { DocumentsHandlerService } from './_infrastructure/Documents/DocumentHandlerService';
import { NIFValidationDirective } from './_infrastructure/NifValidation/NIFValidationDirective';
import { IBANValidationDirective } from './_infrastructure/IBANValidationDirective';
import { SpecialCharactersDirective } from './_infrastructure/SpecialCharactersDirective';
import { StepDetailsService } from './_infrastructure/StepDetailsService/StepDetailsService';
import { PreventInputDirective } from './_infrastructure/PreventInputDirective';
import { ClinicalSituationComponent } from './workflows/cards/ClinicalInformation/clinical-situation.component';
import { IncapacityEvaluationComponent } from './workflows/cards/ClinicalInformation/incapacity-evaluation.component';
import { XsrfInterceptor } from './_infrastructure/ExceptionHandler/XsrfInterceptor';
import { EscolhaVinculo1RadioOptionElement, EscolhaVinculo2RadioOptionElement, PerguntaConcorda1RadioOptionElement } from './workflow-instance-creator/FakeChildClassRadioOption'
import { PreStageDocumentationComponent } from './workflow-instance-creator/documentation/prestage-documentation.component';
import { PreStageDocumentationTableEditComponent } from './workflow-instance-creator/documentation/prestage-documentation-table-edit.component';
import { VinculosListComponent } from './workflow-instance-creator/vinculos/vinculos-list.component';

// Prestações por morte
import { WorkflowInstanceCreatorComponentPM } from './workflow-instance-creator-pm/workflow-instance-creator-pm.component';
import { ProfessionalCategoryComponent } from './workflows/cards/ProfessionalCategory/professional-category.component';
import { DeceasedObservationsComponent } from './workflows/cards/DeceasedObservations/deceased-observations.component';
import { WorkAbroadTableEditPMComponent } from './workflows/cards/ProfessionalCategory/work-abroad-table-edit-pm.component';
import { BeneficiaryListComponent } from './workflows/cards/BeneficiaryList/beneficiary-list.component';
import { BeneficiaryListTableEditComponent } from './workflows/cards/BeneficiaryList/beneficiary-list-table-edit.component';
import { PersonTypeComponent } from './workflows/cards/BeneficiaryList/Components/PersonType/person-type.component';
import { BenefitTypeComponent } from './workflows/cards/BeneficiaryList/Components/BenefitType/benefit-type.component';
import { BeneficiaryIdentificationComponent } from './workflows/cards/BeneficiaryList/Components/BeneficiaryIdentification/beneficiary-identification.component';
import { BeneficiaryContactsComponent } from './workflows/cards/BeneficiaryList/Components/BeneficiaryContacts/beneficiary-contacts.component';
import { DeceasedRelationshipComponent } from './workflows/cards/BeneficiaryList/Components/DeceasedRelationship/deceased-relationship.component';
import { LegalRepresentationIdentificationComponent } from './workflows/cards/BeneficiaryList/Components/LegalRepresentationIdentification/legal-representation-identification.component';
import { TaxInformationComponent } from './workflows/cards/BeneficiaryList/Components/TaxInformation/tax-information.component';
import { PaymentComponent } from './workflows/cards/BeneficiaryList/Components/Payment/payment.component';
import { BeneficiaryObservationsComponent } from './workflows/cards/BeneficiaryList/Components/BeneficiaryObservations/beneficiary-observations.component';
import { NotificationsComponent } from './workflows/cards/BeneficiaryList/Components/Notifications/notifications.component';
import { WorkflowComponentNew } from './workflows/workflow-new.component';
import { StepComponentNew } from './workflows/step-new.component';
import { DocumentationPMComponent } from './workflows/cards/DocumentationPM/documentation-pm.component';
import { DocumentationTableEditPMComponent } from './workflows/cards/DocumentationPM/documentation-table-edit-pm.component';
import { SendWorkflowPMComponent } from './workflows/cards/SendWorkflowPM/send-workflow-pm.component';

import { DocumentsNeededComponent } from './_infrastructure/Documents/documents-needed.component';

import { SenderQualificationComponent } from './workflows/cards/SenderQualification/sender-qualification.component';
import { SenderIdentificationComponent } from './workflows/cards/SenderIdentification/sender-identification.component';
import { SenderObservationsComponent } from './workflows/cards/SenderObservations/sender-observations.component';
import { SenderContactsComponent } from './workflows/cards/SenderContacts/sender-contacts.component';
import { DeceasedIdentificationComponent } from './workflows/cards/DeceasedIdentification/deceased-identification.component';
//PRESTAGE Prestações por morte
import { SenderQualificationPreStageComponent } from './workflow-instance-creator-pm/cards/SenderQualification/sender-qualification-pre-stage.component';
import { DeceasedIdentificationPreStageComponent } from './workflow-instance-creator-pm/cards/DeceasedIdentification/deceased-identification-pre-stage.component';
import { RepresentadosListPreStageComponent } from './workflow-instance-creator-pm/cards/RepresentadosList/representados-list-pre-stage.component';
import { RepresentadosListTableEditPreStageComponent } from './workflow-instance-creator-pm/cards/RepresentadosList/representados-list-table-edit-pre-stage.component';
import { DocumentationPMPreStageComponent } from './workflow-instance-creator-pm/cards/DocumentationPM/documentation-pm-pre-stage.component';
import { DocumentationTableEditPMPreStageComponent } from './workflow-instance-creator-pm/cards/DocumentationPM/documentation-table-edit-pm-pre-stage.component';
import { ExistingRequestPMModalComponent } from './workflow-instance-creator-pm/modals/existing-request-pm.component';
import { SenderIdentificationPreStageComponent } from './workflow-instance-creator-pm/cards/SenderIdentification/sender-identification-pre-stage.component';
import { ServiceIdentificationPreStageComponent } from './workflow-instance-creator-pm/cards/ServiceIdentification/service-identification-pre-stage.component';
import { SenderContactsPreStageComponent } from './workflow-instance-creator-pm/cards/SenderContacts/sender-contacts-pre-stage.component';
import { SubmitPreStagePMComponent } from './workflow-instance-creator-pm/cards/SubmitPreStagePM/submit-pre-stage-pm.component';
import { BeneficiaryListPreStageComponent } from './workflow-instance-creator-pm/cards/BeneficiaryList/beneficiary-list-pre-stage.component';
import { BeneficiaryListTableEditPreStageComponent } from './workflow-instance-creator-pm/cards/BeneficiaryList/beneficiary-list-table-edit-pre-stage.component';
import { DropdownsPipe } from './_infrastructure/Dropdowns/DropDownsPipe';
import { SubmitPreStageRequestModalComponent } from './workflow-instance-creator-pm/modals/submit-pre-stage-request.component';
import { DoNothingPMComponent } from './workflow-instance-creator-pm/cards/DoNothing/do-nothing.component';

@NgModule({
  declarations: [
    AppComponent,
    ShellComponent,
    HeaderComponent,
    //ButtonPrimaryComponent,
    //GuidelinesComponent,
    //ButtonsComponent,
    //TypographyComponent,
    EmptyToNullDirective,
    ToQueryStringPipe,
    ToIconPipe,
    CommaToPointPipe,
    ToIconClassPipe,
    CurrencyFormatterDirective,
    NumericDirective,
    PercentageDirective,
    CommonDataPipe,
    CommonDataListPipe,
    DebounceClickDirective,
    DragDropDirective,
    StepComponent,
    WorkflowComponent,
    WorkflowSearchComponent,
    WorkflowInstanceCreatorComponent,
    SubscriberInfoComponent,
    SubscriberIdentificationComponent, 
    SubscriberContactsComponent, 
    ServiceIdentificationComponent,
    //ColorsComponent, 
    //IconsComponent, 
    //CardComponent, 
    //SearchboxComponent, 
    //TextfieldComponent, 
    SubscriberContactsComponent, 
    ServiceIdentificationComponent,    
    ExternalPensionStatusComponent,
    WorkAbroadTableEditComponent,
    SubscriberFiscalInformationComponent,
    SubscriberPaymentInformationComponent,
    CGAPensionStatusComponent,
    EffectivityMapComponent,
    EffectivityTableEditComponent,
    IncapacityTableEditComponent,
    MilitaryInformationComponent,
    TimeCountComponent,
    FamilyBenefitsComponent,
    FamilyBenefitsTableEditComponent,
    RemunerationsTrienniumComponent,
    RemunerationPeriodTableEditComponent,
    RemunerationsLastUntilCutoffComponent,
    RemunerationOtherTableEditComponent,
    RemunerationsLastThreeYearsComponent,
    RemunerationsCurrentMonthlyComponent,
    RemunerationsMilitaryComponent,
    EffectivityTimelineComponent,
    DocumentationComponent,
    DocumentationHelpComponent,
    DocumentationTableEditComponent,
    CommunicationDetailComponent,
    ObservationsComponent,
    ServiceContactsComponent,
    SendWorkflowComponent,
    BaseModalComponent,
    //ColorsComponent, ButtonSecondaryComponent, ButtonLinksComponent, SpinnerComponent, ToastmessagesComponent, SelectComponent, CheckboxComponent, TableComponent, DatepickerComponent, CollapseContentComponent, SidebarComponent,
    //ToogleButtonComponent, CardShadowComponent,
    ValidationMessageComponent,
    //ModalComponent,
    //TooltipComponent,
    //TimelineComponent,
    //FileinputComponent,
    ExternalValidationDirective,
    RowExternalValidationDirective,
    RadioLabelDirective,
    MaxValueDirective,
    MinValueDirective,
    ClearRelatedFieldsDirective,
    ExactLengthDirective,
    DefaultDropdownValueComponent,
    DropdownTitleDirective,
    VisualActionUnauthorizedDirective,
    NullableSelectDirective,
    LoadingMaskComponent,
    SubmissionLandingPageComponent,
    ExSubsConfirmSubmissionComponent,
    ConfirmSubmissionComponent,
    NIFValidationDirective,
    IBANValidationDirective,
    SpecialCharactersDirective,
    InstanceBrowserComponent,
    InstanceBrowserDetailComponent,
    PreventInputDirective,
    ClinicalSituationComponent,
    IncapacityEvaluationComponent,
    EscolhaVinculo1RadioOptionElement,
    EscolhaVinculo2RadioOptionElement,
    PerguntaConcorda1RadioOptionElement,
    PreStageDocumentationComponent,
    PreStageDocumentationTableEditComponent,
    VinculosListComponent,
    WorkflowInstanceCreatorComponentPM,
    SenderQualificationComponent,
    SenderIdentificationComponent,
    SenderObservationsComponent,
    SenderContactsComponent,
    DeceasedIdentificationComponent,
    DocumentsNeededComponent,
    ProfessionalCategoryComponent,
    WorkAbroadTableEditPMComponent,
    DeceasedObservationsComponent,
    BeneficiaryListComponent,
    BeneficiaryListTableEditComponent,
    PersonTypeComponent,
    BenefitTypeComponent,
    BeneficiaryIdentificationComponent,
    BeneficiaryContactsComponent,
    DeceasedRelationshipComponent,
    LegalRepresentationIdentificationComponent,
    TaxInformationComponent,
    PaymentComponent,
    BeneficiaryObservationsComponent,
    NotificationsComponent,
    
    WorkflowComponentNew,
    StepComponentNew,
    DocumentationPMComponent,
    DocumentationTableEditPMComponent,
    SendWorkflowPMComponent,
    SenderQualificationPreStageComponent,
    DeceasedIdentificationPreStageComponent,
    RepresentadosListPreStageComponent,
    RepresentadosListTableEditPreStageComponent,
    DocumentationPMPreStageComponent,
    DocumentationTableEditPMPreStageComponent,
    ExistingRequestPMModalComponent,
    SenderIdentificationPreStageComponent,
    ServiceIdentificationPreStageComponent,
    SenderContactsPreStageComponent,
    SubmitPreStagePMComponent,
    BeneficiaryListPreStageComponent,
    BeneficiaryListTableEditPreStageComponent,
    DropdownsPipe,
    SubmitPreStageRequestModalComponent,
    VinculosListComponent,
    DoNothingPMComponent
    //SHARED COMPONENTS
  ],
  imports: [
    //NGX_MASK
    NgxMaskModule.forRoot(),
    BrowserModule, //.withServerTransition({ appId: 'ng-cli-universal' }),
    BrowserAnimationsModule,
    AppRoutingModule,

    // PIT40802 \\
    ValidatePGPOnlineComponent,

    // Tem que ser sempre depois do AppRouting pois esmaga o UrlSerializer
    //HttpClientModule,
    // Usamos a versão corrected para corrigir o tratamento de datas nos parâmetros e connection strings
    CorrectedHttpClientModule,

    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    FormsModule,
    ProgressbarModule.forRoot(),
    BsDatepickerModule.forRoot(),
    CollapseModule.forRoot(),
    TabsModule.forRoot(),
    ModalModule.forRoot(),
    TooltipModule.forRoot(),
    //HighchartsChartModule,
    AlertModule,
    //HighlightModule
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initConfig,
      deps: [SystemInformationService, NSIAuthService],
      multi: true
    },
    //CurrencyPipe,
    DatePipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: StripUndefinedParams,
      multi: true
    },
    
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorHandler,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NoCacheInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: XsrfInterceptor,
      multi: true
    },

    {
      provide: LOCALE_ID,
      deps: [LanguageService],
      useFactory: (languageService: LanguageService) => languageService.currentLocale
    },
    //{
    //  provide: HIGHLIGHT_OPTIONS,
    //  useValue: {
    //    lineNumbers: false,
    //  } as HighlightOptions
    //},
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'EUR' },
    ValidationMessageService,
    ExternalValidationsService,
    SubscriberInformationService,
    CommonDataPipe,
    SystemInformationService,
    AsyncDataService,
    DocumentsHandlerService,
    StepDetailsService,
    CorrectedHttpClient
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(localeService: BsLocaleService) {
    defineLocale('pt-br', ptBrLocale);
    localeService.use('pt-br');
    (<any>JSON).useDateParser();
  }
}
